<template>
  <div class="exchange-container">
    <van-popup v-model="showPicker" position="center" round class="chain-popup">
      <div class="popup-content">
        <div class="popup-header">
          <span class="title">{{ $t("lang.swap436") }}</span>
          <van-icon name="cross" class="close-icon" @click="showPicker = false" />
        </div>

        <div class="search-container">
          <div class="search-bar">
            <van-icon name="search" class="search-icon" />
            <input type="text" :placeholder="$t('lang.swap437')" v-model="searchText" />
          </div>
        </div>

        <div class="chain-list-wrapper">
          <div class="list-item">
            <div class="all-chain_left">
              <img src="@/assets/img/CrossChainBridge_icon7.svg" alt="">
              <span class="name">{{ $t("lang.swap438") }}</span>
            </div>
            <div class="all-chain_right">
              <div v-for="item in chainList" class="chain" :class="currentChain.name == item.name ? 'chain_active' : ''"
                @click="currentChain = item;">
                <img :src="item.img" alt="">
              </div>
            </div>
          </div>

          <div class="section-title">{{ $t("lang.swap439") }}</div>

          <div v-for="(item, index) in currentChain.tokens" :key="index" @click="changeToken(item)" class="list-item">
            <div class="chain-icon-bg" :class="{ 'gray-circle': !item.img }">
              <img v-if="item.img" :src="item.img" :alt="item.name">
            </div>
            <span class="name">{{ item.name }}</span>
          </div>
        </div>
      </div>
    </van-popup>
    <div class="card-box">
      <div class="card-header">
        <span class="label">{{ $t("lang.swap440") }}</span>
        <div class="token-selector" @click="showPicker = true">
          <img src="@/assets/tokenlogo/BNB.png" alt="bnb" class="token-icon">
          <div class="token-info">
            <div class="token-name">BNB</div>
            <div class="token-chain">bsc</div>
          </div>
          <i class="arrow-down"></i>
        </div>
      </div>
      <div class="card-body">
        <div class="amount-main">0.00</div>
        <div class="amount-sub">
          <img src="@/assets/img/CrossChainBridge_icon1.svg" alt="">
          <i class="icon-swap"></i> $0.00
        </div>
      </div>
      <div class="card-footer">
        {{ $t("lang.swap441") }}: <span class="balance-val">0</span>
      </div>
    </div>

    <div class="swap-divider">
      <div class="arrow-circle">
        <i class="icon-down">↓</i>
      </div>
    </div>

    <div class="card-box">
      <div class="card-header">
        <div class="label-row">
          <span class="label">{{ $t("lang.swap442") }}</span>
          <i class="icon-edit">✎</i>
        </div>
        <div class="token-selector" @click="showPicker = true">
          <img src="@/assets/tokenlogo/BNB.png" alt="bnb" class="token-icon">
          <div class="token-info">
            <div class="token-name">BNB</div>
            <div class="token-chain">bsc</div>
          </div>
          <i class="arrow-down"></i>
        </div>
      </div>
      <div class="card-body">
        <div class="amount-main highlight">0.00</div>
        <div class="amount-sub">
          <img src="@/assets/img/CrossChainBridge_icon1.svg" alt="">
          <i class="icon-swap"></i> $0.00
        </div>
      </div>
      <div class="card-footer">
        {{ $t("lang.swap441") }}: <span class="balance-val">0</span>
      </div>
    </div>

    <div class="status-bar">
      <div class="status-header">
        <span class="status-title">
          <img src="@/assets/img/CrossChainBridge_icon2.svg" alt=""> {{ $t("lang.swap443") }}
        </span>
        <i class="arrow-down-small"></i>
      </div>
      <div class="status-details">
        <img src="@/assets/img/CrossChainBridge_icon3.svg" alt="">
        <span class="divider">|</span>
        <span class="detail-item"><img src="@/assets/img/CrossChainBridge_icon4.svg" alt=""> $0.03 (-0.0%)</span>
        <span class="divider">|</span>
        <span class="detail-item"><img src="@/assets/img/CrossChainBridge_icon5.svg" alt=""> $0.00</span>
        <span class="divider">|</span>
        <span class="detail-item"><img src="@/assets/img/CrossChainBridge_icon6.svg" alt=""> ~2秒</span>
      </div>

      <button class="action-btn disabled">{{ $t("lang.swap444") }}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExchangeCard',
  data() {
    return {
      showPicker: false, // 默认打开预览
      searchText: '',
      chainList: [
        {
          name: 'BSC',
          img: require('@/assets/tokenlogo/BNBnetwork.png'),
          tokens: [
            {
              name: 'BNB',
              img: require('@/assets/tokenlogo/BNB.png'),
            },
            {
              name: 'USDT',
              img: require('@/assets/tokenlogo/USDT.png'),
            },
            {
              name: 'ETH',
              img: require('@/assets/tokenlogo/ETH.webp'),
            },
            {
              name: 'USDC',
              img: require('@/assets/tokenlogo/USDC.webp'),
            },
            {
              name: 'DOGE',
              img: require('@/assets/tokenlogo/DOGE.webp'),
            },
          ]
        },
        {
          name: 'ETH',
          img: require('@/assets/tokenlogo/ETH.png'),
          tokens: [
            {
              name: 'ETH',
              img: require('@/assets/tokenlogo/ETH.png'),
            },
            {
              name: 'USDT',
              img: require('@/assets/tokenlogo/USDT.png'),
            },
            {
              name: 'USDC',
              img: require('@/assets/tokenlogo/USDC.webp'),
            },

          ]
        },
        {
          name: 'TRX',
          img: require('@/assets/tokenlogo/TRX.png'),
          tokens: [
            {
              name: 'TRX',
              img: require('@/assets/tokenlogo/TRX.png'),
            },
            {
              name: 'USDT',
              img: require('@/assets/tokenlogo/USDT.png'),
            },
          

          ]
        },
      ],
      currentChain: [],
    };
  },
  mounted() {
    this.currentChain = this.chainList[0];
  },
  methods: {
    changeToken(item) {
      this.showPicker = false;
      this.$toast(this.$t("lang.swap444"));
      return;
      this.currentToken = item;
    }
  }
};
</script>

<style lang="less" scoped>
// 基础变量
@bg-color: #1a0f0a;
@card-bg: rgba(43, 28, 20, 0.8);
@text-main: #f5f5f5;
@text-sub: #8c7e76;
@accent-orange: #d97706;
@highlight-cyan: #00f2ff;

.exchange-container {
  //   background-color: @bg-color;
  //   padding: 20px;
  padding: 14px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  border-radius: 20px;
  color: @text-main;

  .card-box {
    background-color: @card-bg;
    padding: 17px 14px;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.05);
    position: relative;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .label {
        font-size: 18px;
        font-weight: 500;
      }

      .label-row {
        display: flex;
        align-items: center;
        gap: 8px;

        .icon-edit {
          font-size: 14px;
          color: @text-sub;
          cursor: pointer;
        }
      }
    }

    .token-selector {
      background: rgba(255, 255, 255, 0.08);
      padding: 8px 16px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      gap: 10px;
      border: 1px solid rgba(255, 255, 255, 0.1);
      cursor: pointer;

      .token-icon {
        width: 32px;
        height: 32px;
        border-radius: 50%;
      }

      .token-name {
        font-weight: bold;
        font-size: 16px;
      }

      .token-chain {
        font-size: 12px;
        color: @text-sub;
        margin-top: -2px;
      }

      .arrow-down {
        border: solid @text-sub;
        border-width: 0 2px 2px 0;
        display: inline-block;
        padding: 3px;
        transform: rotate(45deg);
        margin-left: 8px;
        margin-bottom: 4px;
      }
    }

    .card-body {
      margin-top: 10px;

      .amount-main {
        font-size: 36px;
        font-weight: 500;
        color: @accent-orange;

        &.highlight {
          color: @highlight-cyan;
        }
      }

      .amount-sub {
        font-size: 14px;
        color: @text-sub;
        margin-top: 4px;
      }
    }

    .card-footer {
      text-align: right;
      font-size: 14px;
      color: @text-sub;
      margin-top: 10px;

      .balance-val {
        color: @accent-orange;
      }
    }
  }

  .swap-divider {
    height: 10px;
    position: relative;
    z-index: 2;
    display: flex;
    justify-content: center;
    align-items: center;

    .arrow-circle {
      background: #2b1c14;
      border: 4px solid @bg-color;
      width: 40px;
      height: 40px;
      border-radius: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: white;
      font-weight: bold;
    }
  }

  .status-bar {
    background-color: @card-bg;
    margin-top: 15px;
    padding: 16px;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.05);

    .status-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .status-title {
        color: @accent-orange;
        font-size: 14px;
        font-weight: bold;
        display: flex;
        align-items: center;
        gap: 5px;
      }
    }

    .status-details {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-top: 12px;
      font-size: 12px;
      color: @text-sub;

      .divider {
        color: #3d2c24;
      }
    }

    .action-btn {
      width: 100%;
      height: 54px;
      margin-top: 20px;
      border-radius: 16px;
      border: none;
      background: rgba(255, 255, 255, 0.05);
      color: #DEA98E;
      font-size: 13px;
      font-weight: bold;
      cursor: not-allowed;
      transition: all 0.3s;

      &.disabled {
        color: #705b50;
      }
    }
  }
}

.chain-popup {
  background: linear-gradient(143.12deg, rgba(8, 3, 2, 0.82) 0%, rgba(8, 3, 2, 0.89) 100%);

  border: 1px solid #624E44;
  height: 80vh; // 对应图中的高度感
  width: 90%;
  color: @text-main;

  .popup-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 20px;
  }

  .popup-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title {
      font-size: 18px;
      font-weight: 500;
      color: rgba(222, 169, 142, 1);
    }

    .close-icon {
      font-size: 20px;
      color: @text-sub;
    }
  }

  .search-container {
    margin-bottom: 20px;

    .search-bar {
      background: rgba(255, 255, 255, 0.05);
      border: 1px solid @accent-orange; // 突出搜索框边框
      border-radius: 12px;
      padding: 12px 15px;
      display: flex;
      align-items: center;
      gap: 10px;

      .search-icon {
        color: @text-sub;
        font-size: 18px;
      }

      input {
        background: transparent;
        border: none;
        color: @text-main;
        width: 100%;
        outline: none;

        &::placeholder {
          color: #5c4d44;
        }
      }
    }
  }

  .chain-list-wrapper {
    flex: 1;
    overflow-y: auto;

    // 隐藏滚动条
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #3d2c24;
      border-radius: 10px;
    }

    .section-title {
      color: @text-sub;
      font-size: 14px;
      margin: 15px 0;
    }

    .list-item {
      display: flex;
      align-items: center;
      padding: 12px 0;
      gap: 15px;
      cursor: pointer;

      .all-chain_left {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      .all-chain_right {
        display: flex;
        flex: 1;
        gap: 10px;

        .chain {
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 1px solid #624E44;
          border-radius: 6px;

          img {
            width: 24px;
            height: 24px;
            border-radius: 100%;
          }
        }

        .chain_active {
          background: #B3542C;
        }
      }

      .name {
        font-size: 14px;
        font-weight: 500;
        color: rgba(222, 169, 142, 1);
      }

      // 模拟“全部”图标
      .icon-box-grid {
        width: 32px;
        height: 32px;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 3px;

        span {
          background: @accent-orange;
          border-radius: 2px;
        }
      }

      .chain-icon-bg {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        &.gray-circle {
          background-color: #555; // 对应图中未加载图标的占位
        }
      }
    }
  }
}

// 调试按钮样式
.debug-btn {
  margin: 50px;
  padding: 10px 20px;
  background: @accent-orange;
  border: none;
  border-radius: 8px;
  color: white;
}
</style>